import { gql } from '@reverbdotcom/commons/src/gql';

export const CREATE_TRADE_IN = gql(`
  mutation Core_CreateTradeIn(
    $input: CreateTradeInInput!
  ) {
    createTradeIn(input: $input) {
      _id
      id
      dealerAddress {
        _id
        streetAddress
        locality
        region
        postalCode
      }
    }
  }
`);

export const TRADE_IN_CP_ELIGIBILITY_QUERY = gql(`
  query Core_Trade_In_CP_Eligibility($canonicalProductId: String) {
    canonicalProductEligibility: tradeInEligibility(
      input: { canonicalProductId: $canonicalProductId }
    ) {
      isEligible
      appraisals {
        price {
          amountCents
          currency
          display
        }
        condition {
          conditionUuid
        }
      }
    }
  }
`);

export const TRADE_IN_CSP_QUERY = gql(`
  query Core_Trade_In_CSP($cspId: String, $priceRecommendationCountryCode: String) {
    cspEligibility: tradeInEligibility(input: { cspId: $cspId }) {
      appraisals {
        price {
          amountCents
          currency
        }
        condition {
          conditionUuid
        }
      }
      dealers {
        _id
        id
        name
        user {
          _id
          avatar {
            _id
            source
          }
        }
        tradeInStorefront {
          _id
          id
          shopName
        }
      }
    }
    csp(input: { id: $cspId }) {
      _id
      id
      image(input: { transform: "card_square" }) {
        _id
        source
      }
      title
      categoryRootUuid
      brand {
        _id
        name
        slug
      }
      finishes
      canonicalProducts {
        _id
        id
        name
      }
      categories {
        _id
        slug
        root
        rootSlug
      }
      ... CSPPriceRecommendationData
    }
  }
`);

export const DEALER_TRADE_IN_QUERY = gql(`
  query Core_Dealer_Trade_In($tradeInId: String) {
    tradeIn(input: { id: $tradeInId }) {
      _id
      id
      createdAt
      haveAppraisalsChanged
      canonicalProduct {
        id
        name
        make
        primaryImage(input: { transform: "card_square" }) {
          _id
          source
        }
      }
      seller {
        _id
        name
      }
      appraisals {
        condition {
          conditionUuid
          conditionSlug
          displayName
        }
        price {
          display
        }
      }
      originalAppraisals {
        condition {
          conditionUuid
          conditionSlug
        }
        price {
          display
        }
      }
    }
  }
`);

export const TRADE_IN_ELIGIBILITY_QUERY = gql(`
  query Core_Trade_In_Eligibility($cspId: String) {
    tradeInEligibility(input: { cspId: $cspId }) {
      isEligible
    }
  }
`);
